import React, { useContext, useEffect, useState } from 'react';
import PopUpAlert from '../../../component/PopUpAlert';
import Loader from '../../../component/Loader';
import { useSelector } from 'react-redux';
import { RiImageEditFill } from 'react-icons/ri';
import { ClubAPI } from '../../../api/ClubAPI';
import { GameAPI } from '../../../api/GameAPI';
import { HiShieldCheck } from "react-icons/hi";
import { AuthContext } from '../../auth/AuthContext';
import { Box, Button, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select, TextareaAutosize, useTheme } from '@mui/material';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../redux/reducer/rootReducer';
import { PrivilegeAPI } from '../../../api/PrivilegesAPI';
import { Privileges } from '../../../util/PrivilegeConstants';

const ClubProfile = () => {
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);

  const { getCurrentUser } = useContext(AuthContext);
  const [image, setImage] = useState('');
  const [imagePre, setImagePre] = useState('');
  const [loading, setLoading] = useState(false);
  const [clubDesc, setClubDesc] = useState('');
  const [gameNames, setGameNames] = useState([]);
  const [gameIds, setGameIds] = useState([]);
  const [privileges, setPrivileges] = useState({});

  const dispatch=useDispatch();

  const theme = useTheme();
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  function getStyles(name, personName, theme) {
    return {
      fontWeight: personName.includes(name)
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular,
    };
  }


  const handleChange = (event) => {
    const { value } = event.target;
    setGameIds(typeof value === 'string' ? value.split(',') : value)
  };
  const getAllGameNames = async () => {
    try {
      const response = await GameAPI.getGamesByPlatform();
      setGameNames(response);
    } catch (error) {

    }
  }
  const findGameNameById = (gameId) => {
    const game = gameNames.find((g) => g.gameId === gameId);
    return game?.gameName;
  };

  const findAllPrivileges = async () => {
    try {
      setLoading(true)
      const reqObj = {
        userId: userInfo.userId,
        featureName: Object.keys(Privileges)[14]
      }
      const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
      setPrivileges(response.Data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userInfo.userId) {
      findAllPrivileges();
    }
  }, [userInfo.userId]);

  useEffect(() => {
    setImagePre(selectedClub?.clubLogo ? import.meta.env.VITE_APP_BASE_URL + '/club/club-logo-img/' + selectedClub.clubLogo : null);
    setClubDesc(selectedClub?.clubDescription);

    setGameIds(userInfo.clubs[0].gameIds ? selectedClub.gameIds : [])
    getAllGameNames();
  }, [])


  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const maxSizeInMB = 5;
    if (file.type === "image/webp" || file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif") {

      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > maxSizeInMB) {
        dispatch(rootAction.setWarningMessage({id:Date.now(), type: 'info', content: "upload image under 5 MB" }));
      }
      else {
        setImage(file);
        setImagePre(URL.createObjectURL(file));
      }
    } else {
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'warning', content: "upload .jpg, .jpeg, .png, .gif,.webp file" }));
    }
  }
  const updateClubDetails = async (e) => {
    e.preventDefault();
    // NOTE: API for uload logo
    try {
      setLoading(true);
      const response = await ClubAPI.updateClubDetails({ clubDescription: clubDesc, gameIds: gameIds }, image, selectedClub?.clubId);
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: response.Data }));
      setLoading(false);
      getCurrentUser();
    } catch (error) {
      console.error(error);

      setLoading(false);
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: "Please contact customer support" }));
    }

  }
  return (
    <form className="user-profile-container" onSubmit={updateClubDetails}>
      {loading && <Loader />}
      <div className="user-profile-image-section">
        <div className="user-profile-image">
          <label htmlFor="file_upload" className="profile_image_edit">
            <RiImageEditFill className="profile_image_edit_icon" />
          </label>
          <label className="profile_image_preview">
            <img
              loading="lazy"
              src={imagePre}
              alt=""
            />
          </label>
          <input
            type="file"
            id="file_upload"
            name="image"
            onChange={handleImageUpload}
          />
        </div>
        <div className="user-profile-heading">
          <h1>{userInfo.clubs[0].clubName}</h1>
          <p>
            <HiShieldCheck className="user-account-status" /> Club verified
          </p>
        </div>
      </div>

      <div className="user-profile-date-mobile-section">
        <TextareaAutosize
          maxLength={1000}
          value={clubDesc || ''}
          onChange={(e) => setClubDesc(e.target.value)}
          className='club_profile_description_field'
          placeholder='Write your club description here.....' />
      </div>
      <FormControl sx={{ width: '100%' }}
        className="signup-text-input"
      >

        <InputLabel id="demo-multiple-chip-label">Game Interested?</InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={gameIds}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" label="Game Interested?" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={findGameNameById(value)} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {gameNames?.map((name) => (
            <MenuItem
              key={name.gameId}
              value={name.gameId}
              style={getStyles(name.gameId, name.gameName, theme)}
            >
              {name.gameName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {privileges?.MANAGE_CLUB_PROFILE?.includes(Privileges.MODIFY) &&
      <div className="user-profile-save-btn">
        <Button type="submit" variant="contained">
          Save
        </Button>
      </div>}
    </form>
  )
}

export default ClubProfile